import axios from "./axios";

export const postTheTweet = async (topic, tweetid) => {
    try {
        const response = await axios.post(`/user_topics`, topic, {
            headers: {
                authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
        return response.data.data;
    } catch (error) {
        throw new Error(error.response.data.error);
    }
}

export const likeTheTweet = async (tweetid) => {
    try {
        const response = await axios.post(`/api/tweet/${tweetid}/like`, null, {
            headers: {
                authorization: localStorage.getItem('token'),
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response.data.error);
    }
}
export const unlikeTheTweet = async (tweetid) => {
    try {
        const response = await axios.post(`/api/tweet/${tweetid}/unlike`, null, {
            headers: {
                authorization: localStorage.getItem('token'),
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response.data.error);
    }
}

export const fetchTheTweet = async (tweetid) => {
    try {
        const response = await axios.get(`/user_topics/${tweetid}`,{
            headers: {
                authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
        return response.data.data;
    } catch (error) {
        throw new Error(error.response.data.error);
    }
}

export const postTheTweetReply = async (tweetText, tweetPic, tweetid) => {
    try {
        const response = await axios.post(`/api/tweet/post/${tweetid}/reply`, {
            tweetText,
            tweetPic,
        }, {
            headers: {
                authorization: localStorage.getItem('token'),
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response.data.error);
    }
}

export const postTheRetweet = async (tweetid) => {
    try {
        const response = await axios.post(`/api/tweet/post/${tweetid}/retweet`, null, {
            headers: {
                authorization: localStorage.getItem('token'),
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response.data.error);
    }
}

export const deleteTheRetweet = async (tweetid) => {
    try {
        const response = await axios.delete(`/api/tweet/post/${tweetid}/retweet/delete`, {
            headers: {
                authorization: localStorage.getItem('token'),
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response.data.error);
    }
}

export const searchTweets = async (query, filter) => {
    try {
        const response = await axios.post(`/api/search/tweets/`, {
            query,
            filter
        }, {
            headers: {
                authorization: localStorage.getItem('token'),
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response.data.error);
    }
}

export const fetchReplies = async (offset = 0, tweetid) => {
    try {
        const response = await axios.post(`/api/tweet/${tweetid}/replies`, {
            offset
        }, {
            headers: {
                authorization: localStorage.getItem('token'),
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response.data.error);
    }
}

export const bookmarkTweet = async (tweetid) => {
    try {
        const response = await axios.post(`/api/tweet/${tweetid}/bookmark`, null, {
            headers: {
                authorization: localStorage.getItem('token'),
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response.data.error);
    }
}

export const removeBookmarkTweet = async (tweetid) => {
    try {
        const response = await axios.delete(`/api/tweet/${tweetid}/bookmark`, {
            headers: {
                authorization: localStorage.getItem('token'),
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response.data.error);
    }
}
// random/tweets
export const getRandomTweets = async () => {
    try {
        const response = await axios.get(`/user_topics`, {
            headers: {
                authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
        return response.data.data;
    } catch (error) {
        throw new Error(error.response.data.error);
    }
}

export const getTopTopics = async (offset = 1, signal) => {
    try {
        // const response = await axios.get(`/user_topics_orders?page=${offset}`, {
        const response = await axios.get(`/user_topics_orders`, {
            signal: signal,
            headers: {
                authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
        return response.data.data;
    } catch (error) {
        throw new Error(error.response.data.error);
    }
}



export const fetchStaticData = async (type) => {
    try {
        const response = await axios.get(`/static-data?page=${type}`, {
            headers: {
                authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
        return response.data.data;
    } catch (error) {
        throw new Error(error.response.data.error);
    }
}

export const upvoteOpenProject = async (topic_id) => {
    try {
        const response = await axios.post(`/topic_upvotes`, {
            topic_id
        }, {
            headers: {
                authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
        return response.data.data;
    } catch (error) {
        throw new Error(error)
    }
}


export const reactToProject = async (topic_id, reaction_type) => {
    try {
        const response = await axios.post(`/topic_reactions`, {
            topic_id,
            reaction_type
        }, {
            headers: {
                authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
        return response.data.data;
    } catch (error) {
        throw new Error(error.response.data.error);
    }
}


export const getFilteredTopics = async (level_id, category_id=1, data_id) => {
    try {
        let url = `/user_topics?topic_level_id=${level_id}&topic_category_id=${category_id}`;
        if(data_id && data_id != ''){
            url+=`&data_id=${data_id}`
        }
        const response = await axios.get(url, {
            headers: {
                authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
        return response.data.data;
    } catch (error) {
        throw new Error(error.response.data.error);
    }
}

export const getUserTopics = async () =>{
    try{
        const response = await axios.get('get_user_topics', {
            headers: {
                authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
        return response.data.data;
    } catch(error){
        throw new Error(error);
    }
}
